module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "intended-user-edit-dialog",
    attrs: {
      "close-on-click-modal": false,
      "title": "新增合同状态"
    },
    on: {
      "close": function($event) {
        _vm.closeCallBack()
      }
    },
    model: {
      value: (_vm.visiable1),
      callback: function($$v) {
        _vm.visiable1 = $$v
      },
      expression: "visiable1"
    }
  }, [_c('el-form', {
    ref: "dynamicValidateForm",
    staticClass: "demo-dynamic",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同号",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.checkedHthList),
      callback: function($$v) {
        _vm.checkedHthList = $$v
      },
      expression: "checkedHthList"
    }
  }, _vm._l((_vm.AreaList), function(item) {
    return _c('el-checkbox', {
      key: item.Id,
      attrs: {
        "name": "agenththname",
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ProjectTypeName) + "--" + _vm._s(item.ContractNumber))])
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态",
      "required": ""
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeStatus
    },
    model: {
      value: (_vm.form.ContractStatusName),
      callback: function($$v) {
        _vm.$set(_vm.form, "ContractStatusName", $$v)
      },
      expression: "form.ContractStatusName"
    }
  }, _vm._l((_vm.ContractStatusMap), function(item) {
    return _c('el-radio-button', {
      key: item.id,
      attrs: {
        "label": item.name
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showByCS),
      expression: "!showByCS"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收件人",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.Consignee),
      callback: function($$v) {
        _vm.$set(_vm.form, "Consignee", $$v)
      },
      expression: "form.Consignee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收件人电话",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.ConsigneeTel),
      callback: function($$v) {
        _vm.$set(_vm.form, "ConsigneeTel", $$v)
      },
      expression: "form.ConsigneeTel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收件地址",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.ConsigneeAdress),
      callback: function($$v) {
        _vm.$set(_vm.form, "ConsigneeAdress", $$v)
      },
      expression: "form.ConsigneeAdress"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "物流或快递名称",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.LogisticsId),
      callback: function($$v) {
        _vm.$set(_vm.form, "LogisticsId", $$v)
      },
      expression: "form.LogisticsId"
    }
  }, _vm._l((_vm.Logistics), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": _vm.showDialog
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物流或快递单号",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.LogisticsCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "LogisticsCode", $$v)
      },
      expression: "form.LogisticsCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "label": _vm.timeStr,
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.form.ConsigneeTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "ConsigneeTime", $$v)
      },
      expression: "form.ConsigneeTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.Remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "Remark", $$v)
      },
      expression: "form.Remark"
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), (!_vm.isReadOnly) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": function($event) {
        _vm.submitfn()
      }
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "快递/物流管理",
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.dialogClosed
    },
    model: {
      value: (_vm.visibleShow),
      callback: function($$v) {
        _vm.visibleShow = $$v
      },
      expression: "visibleShow"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.Logistics
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ParmName",
      "label": "名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "delete",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.delLogistics(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialogContent),
      callback: function($$v) {
        _vm.dialogContent = $$v
      },
      expression: "dialogContent"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addLogistics
    }
  }, [_vm._v("添 加")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cc3e7c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMFormatAgent/components/optContractStatus/index.vue
// module id = 1406
// module chunks = 1